export default __webpack_public_path__ + "static/media/placeholder140x140.611943cd.svg";